import { render } from "./AppDesktop.header.vue?vue&type=template&id=5a5247c2"
import script from "./AppDesktop.header.vue?vue&type=script&lang=js"
export * from "./AppDesktop.header.vue?vue&type=script&lang=js"

import "./AppDesktop.header.vue?vue&type=style&index=0&id=5a5247c2&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QToolbar,QBtn,QSpace});
